import React from 'react';
import VoiceChatWidget from './VoiceChatWidget';
import classNames from 'classnames';
import './VoiceChatPluginPopup.scss';

export default function VoiceChatPluginPopup({ voiceConfiguration }) {
  const isMobile = typeof window !== 'undefined' && window.innerWidth <= 768;

  const stopEventPropagation = React.useCallback(
    (e) => {
      if (isMobile) {
        e.preventDefault();
        e.stopPropagation();
      }
    },
    [isMobile]
  );

  const position =
    voiceConfiguration?.web_voice_widget_configuration?.chat_plugin_position ||
    'bottom-right';

  return (
    <>
      {isMobile && (
        <div
          className="prospera-overlay-blocker"
          onClick={stopEventPropagation}
          onScroll={stopEventPropagation}
        />
      )}
      <div className={classNames('prospera-popup-container', position)}>
        <VoiceChatWidget voiceConfiguration={voiceConfiguration} />
      </div>
    </>
  );
}
